import axios from "axios";

const api = axios.create({
  baseURL: process.env.REACT_APP_URL_AUTH,
});

api.defaults.validateStatus = () => true;

export default api;
